var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxresearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.0427,
    height: 48.0427,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0427 38.1574L31.6934 29.808C33.8622 27.1555 34.9285 23.7708 34.6718 20.3541C34.4151 16.9374 32.855 13.7501 30.3141 11.4514C27.7733 9.15269 24.4461 7.91853 21.0209 8.00418C17.5956 8.08982 14.3343 9.48871 11.9115 11.9115C9.48871 14.3343 8.08982 17.5956 8.00418 21.0209C7.91853 24.4461 9.15269 27.7733 11.4514 30.3141C13.7501 32.855 16.9374 34.4151 20.3541 34.6718C23.7708 34.9285 27.1555 33.8622 29.808 31.6934L38.1574 40.0427L40.0427 38.1574ZM21.376 32.0427C19.2663 32.0427 17.2041 31.4171 15.4499 30.245C13.6958 29.073 12.3286 27.4071 11.5213 25.458C10.714 23.5089 10.5027 21.3642 10.9143 19.2951C11.3259 17.2259 12.3418 15.3253 13.8335 13.8335C15.3253 12.3418 17.2259 11.3259 19.2951 10.9143C21.3642 10.5027 23.5089 10.714 25.458 11.5213C27.4071 12.3286 29.073 13.6958 30.245 15.4499C31.4171 17.2041 32.0427 19.2663 32.0427 21.376C32.0395 24.204 30.9147 26.9153 28.915 28.915C26.9153 30.9147 24.204 32.0395 21.376 32.0427Z",
    fill: "#FEF335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxresearch);
export default __webpack_public_path__ + "static/media/uxresearch.a229cc14afde7f3193f4be3496588daa.svg";
export { ForwardRef as ReactComponent };